import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import {
  DataTable,
  LoaderIndicator,
  HelperViewContextual,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { MoneyCell } from '@/modules/common/components/MoneyCell';
import { PercentualCell } from '@/modules/common/components/PercentualCell';

import {
  PortfolioPerformancePeriod,
  PortfolioPerformanceResponse
} from '@/modules/wealth/services/portfolio';
import { PerformanceFetchingStatus } from '../../types';

interface Props {
  performanceData?: PortfolioPerformanceResponse | null;
  status: PerformanceFetchingStatus;
}
interface Emit {
  (e: 'on-retry'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PerformanceTable',
  props: {
    performanceData: null,
    status: null
  },
  emits: ["on-retry"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'on-retry'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  performanceData?: PortfolioPerformanceResponse | null;
  status: PerformanceFetchingStatus;
}





const shouldRenderErrorState = computed(() => {
  return props.status === PerformanceFetchingStatus.Error;
});

const shouldRenderLoaderIndicator = computed(() => {
  return (
    props.status === PerformanceFetchingStatus.Loading && !props.performanceData
  );
});

const defaultColumns = [
  {
    label: 'Período',
    getter: (period: PortfolioPerformancePeriod) => period.date.long
  },
  {
    label: 'Rendimento',
    align: 'right',
    component: MoneyCell,
    getter: (period: PortfolioPerformancePeriod) => ({
      text: period.profitValue.formatted,
      align: 'right',
      width: '100%',
      enableToggleMoney: true
    })
  },
  {
    label: 'Rentabilidade',
    align: 'right',
    component: PercentualCell,
    getter: (period: PortfolioPerformancePeriod) => ({
      percentualValue: period.return.value,
      percentualFormatted: period.return.formatted,
      align: 'right',
      width: '100%'
    })
  }
];

const hasData = computed(() => {
  return data.value.length > 0;
});

const data = computed(() => {
  return props.performanceData?.periods || [];
});

const columns = computed(() => {
  return defaultColumns.concat(benchmarksColumns.value);
});

const benchmarksColumns = computed(() => {
  const benchmarks = props.performanceData?.periods?.[0].benchmarks || [];

  return benchmarks.map((benchmark, index) => ({
    label: benchmark.label,
    align: 'right',
    component: PercentualCell,
    getter: (period: PortfolioPerformancePeriod) => ({
      percentualValue: period.benchmarks[index].percentage.value,
      percentualFormatted: period.benchmarks[index].percentage.formatted,
      align: 'right',
      width: '100%'
    })
  }));
});

const handleOnRetry = () => {
  emit('on-retry');
};

return { __sfc: true,props, emit, shouldRenderErrorState, shouldRenderLoaderIndicator, defaultColumns, hasData, data, columns, benchmarksColumns, handleOnRetry, DataTable, LoaderIndicator, HelperViewContextual, HelperViewStatus }
}

})